import { createContext } from 'react'

export interface IMCOnboardingsContext {
  searchQuery: string
  setSearchQuery(value: string): void

  tagsFilter: Array<string>
  setTagsFilter(statusFilter: Array<string>): void
}

export const MCOnboardingsContext = createContext<IMCOnboardingsContext>({
  searchQuery: '',
  setSearchQuery: () => {},

  tagsFilter: [],
  setTagsFilter: () => {},
})
